<template>
    <div v-if="sidebar" class="fixed top-0 left-0 w-full h-full z-50">

        <div v-if="sidebar" @click="sidebar=false"  class=" bg-slate-600 top-0 left-0 w-full h-full  absolute opacity-70"></div>
        <div v-if="sidebar" class="h-full  px-2 w-full md:max-w-2xl max-w-xl bg-white shadow-xl fixed z-50 flex flex-col right-0 top-0 overflow-auto">
                
          <a @click="sidebar=false" class="absolute right-5 top-2 z-50">
            <font-awesome-icon icon="fa-solid fa-times" class="h-5 w-5"></font-awesome-icon> {{ $t('Kapat') }}
         </a>
          <commentPage :in-modal="selected"
            @settab="event=> selected = event"
          ></commentPage>
          <div class="h-10 w-full z-50 fixed bottom-0 right-0 bg-slate-100 py-2 text-center">
  <a @click="sidebar=false" class="text-right px-5">
            <font-awesome-icon icon="fa-solid fa-times" class="h-4 w-4"></font-awesome-icon> {{ $t('Kapat') }}
         </a>
          </div>
        </div>
        
    </div>
</template>
<script setup>
import { ref, reactive, computed, watch, nextTick } from 'vue';
import axios from "axios"; 
import 'vue3-carousel/dist/carousel.css'
import commentPage from '../page/inanc.client.vue'
 
const sidebar = ref(false); 
const selected = ref('comment'); 
 
 
const show = (visibility)=>{
     sidebar.value = visibility
    
}
defineExpose({
    show
})
</script>